import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { finalize, Subject, take } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { BiasingPolicyService } from '../../services/biasing-policy.service';
import { ClientService } from '../../services/client.service';
import { NotificationService } from '../../services/notification.service';
import { BreadcrumbsComponent } from '../../shared/breadcrumbs/breadcrumbs.component';
import { ConfirmModalComponent } from '../../shared/confirm-modal/confirm-modal.component';
import { LoadingComponent } from "../../shared/loading/loading.component";
import { ModalComponent } from '../../shared/modal/modal.component';
import { SearchBarComponent } from "../../shared/searchbar/searchbar.component";
import { SharedTableComponent } from "../../shared/shared-table/shared-table.component";
@Component({
  selector: 'app-client-detail',
  imports: [MatCardModule, MatIconModule, MatTabsModule, MatFormFieldModule, FormsModule, MatTableModule, MatInputModule, SharedTableComponent, MatPaginatorModule, MatSortModule, MatDatepickerModule, MatNativeDateModule, SearchBarComponent, BreadcrumbsComponent, LoadingComponent, MatSlideToggleModule, MatTooltipModule],
  templateUrl: './client-detail.component.html',
  styleUrl: './client-detail.component.scss'
})
export class ClientDetailComponent implements OnInit, OnDestroy {

  id: string | null = null;
  name: string | null = null;

  isActive = false;

  info = 'Attivazione ranking ricerca in base ai click';

  activeTab: string = '';
  isLoading = false;
  hasError = false;
  isLoadingFullScreen = false;

  //Per import in keymatch
  @ViewChild('csvInput')
  csvInput!: ElementRef<HTMLInputElement>;

  //Subjects 
  dynamicNavList$ = new Subject<void>();
  oneboxList$ = new Subject<void>();
  keymatchList$ = new Subject<void>();
  queryCorrelateList$ = new Subject<void>();
  escludiUrlList$ = new Subject<void>();
  policyDiffList$ = new Subject<void>();
  clientById$ = new Subject<void>();

  
  // Stato tabella / query dynamicNav
  dynamicNavSortBy = 'sorting:asc';
  dynamicNavSortField = '';
  dynamicNavSortDirection = '';
  dynamicNavSearchQuery: any = {
    label: '',
    fieldName: ''
  };

  // Stato tabella / query onebox
  oneboxSortBy = 'name:asc';
  oneboxSortField = '';
  oneboxSortDirection = '';
  oneboxSearchQuery: string = '';

  // Stato tabella / query keymatch
  keymatchSortBy = 'keyword:asc';
  keymatchSortField = '';
  keymatchSortDirection = '';
  keymatchSearchQuery: string = '';

  // Stato tabella / query queryCorrelate
  queryCorrelateSortBy = 'keyword:asc';
  queryCorrelateSortField = '';
  queryCorrelateSortDirection = '';
  queryCorrelateSearchQuery: string = '';

   // Stato tabella / query escludiUrl
  escludiUrlSortBy = 'id:asc';
  escludiUrlSortField = '';
  escludiUrlSortDirection = '';
  escludiUrlSearchQuery: string = '';

   // Stato tabella / query policyDiff
  policyDiffSortBy = 'id:asc';
  policyDiffSortField = '';
  policyDiffSortDirection = '';
  policyDiffSearchQuery: string = '';

  // Paginazione server-side dynamicNav
  dynamicNavPageIndex = 0;
  dynamicNavPageSize = 10;
  dynamicNavTotalItems = 0;

  // Paginazione server-side keymatch
  keymatchPageIndex = 0;
  keymatchPageSize = 10;
  keymatchTotalItems = 0;

  // Paginazione server-side onebox
  oneboxPageIndex = 0;
  oneboxPageSize = 10;
  oneboxTotalItems = 0;

  // Paginazione server-side queryCorrelate
  queryCorrelatePageIndex = 0;
  queryCorrelatePageSize = 10;
  queryCorrelateTotalItems = 0;

  // Paginazione server-side escludiUrl
  escludiUrlPageIndex = 0;
  escludiUrlPageSize = 10;
  escludiUrlTotalItems = 0;

  // Paginazione server-side policyDiff
  policyDiffPageIndex = 0;
  policyDiffPageSize = 10;
  policyDiffTotalItems = 0;


  dataSourceDynamicNav = new MatTableDataSource();
  dataSourceKeyMatch = new MatTableDataSource();
  dataSourceOneBox = new MatTableDataSource();
  dataSourceQueryCorrelate = new MatTableDataSource();
  dataSourceEscludiUrl = new MatTableDataSource();
  dataSourcePolicyDiff = new MatTableDataSource();


  //configurazione modale a seconda del tab attivo
  tableConfigs: Record<string, {
    visibleFields: string[],
    nonRequiredFields?: { edit?: string[], add?: string[], delete?: string[] },
    readonlyFields?: {edit?: string[], add?: string[], delete?: string[]},
    hiddenFields: string[],
    labels: Record<string,string>,
    hiddenFieldsValues: Record<string, any>,
    fieldTypes: Record<string,string>,
    selectOptions: Record<string, {value: any, label: string}[]>,
    loadingSelect?: Record<string, boolean>
    errorSelect?: Record<string, boolean>
  }> = {
    dynamicNav: {
      visibleFields: ['label', 'fieldId', 'size', 'orderType', 'orderSort'],
      hiddenFields: ['creationDate'],
      readonlyFields: {},
      labels: {
        label: 'Nome',
        fieldId: 'Field',
        size: 'Size',
        orderType: 'Order Type',
        orderSort: 'Order Sort'
      },
      hiddenFieldsValues: {
        creationDate: new Date().toISOString()
      },
      fieldTypes: {
        label: 'input',
        fieldId: 'select',
        size: 'input',
        orderType: 'select',
        orderSort: 'select'
      },
      selectOptions: {
        orderType: [{
          value:'COUNT',
          label:'count'
        },
        {
          value: 'VALORE',
          label: 'valore'
        }],
        orderSort: [{
          value: 'ASC',
          label: 'asc'
        },
        {
          value: 'DESC',
          label: 'desc'
        }],
        fieldId: [{
          value: '',
          label: ''
        }]
      },
      loadingSelect: {
        fieldId: false
      },
      errorSelect: {
        fieldId: false
      }
    },
    keymatch: {
      visibleFields: ['keyword', 'title', 'description', 'triggerType', 'url', 'imgUrl', 'date'],
      nonRequiredFields: { edit: ['imgUrl'], add: ['imgUrl'] },
      hiddenFields: [],
      readonlyFields: {},
      labels: {
        keyword: 'Keyword',
        title: 'Titolo',
        description: 'Descrizione',
        triggerType: 'Tipo trigger',
        url: 'URL',
        imgUrl: 'Thumb immagine',
        date: 'Selezionare una data'
      },
      hiddenFieldsValues: {},
      fieldTypes: {
        keyword: 'input',
        title: 'input',
        description: 'input',
        triggerType: 'select',
        url: 'input',
        imgUrl: 'input',
        date: 'date'
      },
      selectOptions: {
        triggerType: [
        {
          value: 'PHRASE_MATCH',
          label: 'PHRASE_MATCH'
        },
        {
          value: 'KEYWORD_MATCH',
          label: 'KEYWORD_MATCH'
        },
        {
          value: 'EXACT_MATCH',
          label: 'EXACT_MATCH'
        },
      ]
      }
    },
    onebox: {
      visibleFields: ['name'],
      hiddenFields: [],
      readonlyFields: {},
      labels: {
        name: 'Onebox'
      },
      hiddenFieldsValues: {},
      fieldTypes: {
        name: 'select'
      },
      selectOptions: {
        name: [{
          value: '',
          label: ''
        }]
      },
      loadingSelect: {
        name: false
      },
      errorSelect: {
        name: false
      }
    },
    queryCorrelate: {
      visibleFields: ['keyword', 'rQuery'],
      hiddenFields: [],
      readonlyFields: {},
      labels: {
        keyword: 'Termini di ricerca',
        rQuery: 'Query correlate'
      },
      hiddenFieldsValues: {},
      fieldTypes: {
        keyword: 'input',
        rQuery: 'input'
      },
      selectOptions: {}
    },
    escludiUrl: { 
      visibleFields: ['urlPattern'],
      hiddenFields: [],
      readonlyFields: {},
      labels: {
        urlPattern: 'Pattern URL'
      },
      hiddenFieldsValues: {},
      fieldTypes: {
        urlPattern: 'input'
      },
      selectOptions: {}
    },
    policyDiff: {
      visibleFields: ['selectPolicy'],
      hiddenFields: [],
      readonlyFields: {},
      labels: {selectPolicy: 'Seleziona Policy'},
      hiddenFieldsValues: {},
      fieldTypes: {selectPolicy: 'select'},
      selectOptions: {
        selectPolicy: [{
          value: '',
          label: ''
        }]
      },
      loadingSelect: {
        selectPolicy: false
      },
      errorSelect: {
        selectPolicy: false
      }
    }

  }

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private readonly clientService: ClientService, private readonly biasingService: BiasingPolicyService, private readonly dialog: MatDialog, private readonly notificationService: NotificationService, private readonly auth: AuthenticationService){}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id');
      const encodedName = params.get('name');
      this.name = encodedName ? decodeURIComponent(encodedName) : null;
    });

    this.activeTab = 'dynamicNav';

    if(this.id){
      this.loadDynamicNavigationList(0, 10, this.dynamicNavSortBy, this.id, this.dynamicNavSearchQuery);
      this.loadOneBoxList(0, 10, this.oneboxSortBy, this.id, this.oneboxSearchQuery);
      this.loadQueryRelatedList(0, 10, this.queryCorrelateSortBy, this.id, this.queryCorrelateSearchQuery); 
      this.loadKeymatchList(0,10, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
      this.loadExcludeUrl(0,10, this.escludiUrlSortBy, this.id!, this.escludiUrlSearchQuery);
      this.loadPolicyDiff(0,10, this.policyDiffSortBy, this.id!, this.policyDiffSearchQuery);
      this.loadClientById(this.id);
    
    }

    console.log("tabAttiva", this.activeTab);
    
  }

  loadClientById(clientId: string){
   
    this.clientService.getClientById(clientId).pipe(finalize(() => this.clientById$.next())).subscribe({
      next: (response) => {
        this.isActive = response.autolearning;
      },
      error: () => {
        this.notificationService.getAutolearningInfoError();
      }
    })
  }
  
  loadDynamicNavigationList(pageIndex: number, pageSize: number, sortBy: string, clientId: string, dynamicNavigationFilter: any ){
    this.isLoading = true;
    this.hasError = false;
    this.clientService.getDynamicNavigationList(pageIndex, pageSize, sortBy, clientId, dynamicNavigationFilter ).pipe(finalize(() => { 
      this.isLoading = false;
      this.dynamicNavList$.next();
     })).subscribe({
      next: (response) => {
        this.dataSourceDynamicNav.data = response.content;
        this.dynamicNavTotalItems = response.totalElements;
        // allinea lo stato locale con quanto ritorna il BE
        this.dynamicNavPageIndex = (response?.number ?? pageIndex) ?? 0;
        this.dynamicNavPageSize  = (response?.size ?? pageSize) ?? this.dynamicNavPageSize;
      },
      error: (err) => {
        console.log("errore nel recupero dei dati", err);
        this.dataSourceDynamicNav.data = [];
        this.dynamicNavTotalItems = 0;
        this.hasError = true;
      }
    })
  }

  loadOneBoxList(pageIndex: number, pageSize: number, sortBy: string, clientId: string, oneBoxFilter: string){
    this.isLoading = true;
    this.hasError = false;
    this.clientService.getOneBoxList(pageIndex, pageSize, sortBy, clientId, oneBoxFilter ).pipe(finalize(() => { 
      this.isLoading = false;
      this.oneboxList$.next();
     })).subscribe({
      next: (response) => {
        this.dataSourceOneBox.data = response.content;
        this.oneboxTotalItems = response.totalElements;
        // allinea lo stato locale con quanto ritorna il BE
        this.oneboxPageIndex = (response?.number ?? pageIndex) ?? 0;
        this.oneboxPageSize  = (response?.size ?? pageSize) ?? this.oneboxPageSize;
      },
      error: (err) => {
        console.log("errore nel recupero dei dati", err);
        this.dataSourceOneBox.data = [];
        this.oneboxTotalItems = 0;
        this.hasError = true;
      }
    })
  }

  loadQueryRelatedList(pageIndex: number, pageSize: number, sortBy: string, clientId: string, relatedQueryFilter: string){
    this.isLoading = true;
    this.hasError = false;
    this.clientService.getRelatedQueryList(pageIndex, pageSize, sortBy, clientId, relatedQueryFilter ).pipe(finalize(() => { 
      this.isLoading = false;
      this.queryCorrelateList$.next();
     })).subscribe({
      next: (response) => {
        this.dataSourceQueryCorrelate.data = response.content;
        this.queryCorrelateTotalItems = response.totalElements;
        // allinea lo stato locale con quanto ritorna il BE
        this.queryCorrelatePageIndex = (response?.number ?? pageIndex) ?? 0;
        this.queryCorrelatePageSize  = (response?.size ?? pageSize) ?? this.queryCorrelatePageSize;
      },
      error: (err) => {
        console.log("errore nel recupero dei dati", err);
        this.dataSourceQueryCorrelate.data = [];
        this.queryCorrelateTotalItems = 0;
        this.hasError = true;
      }
    })
  }

  loadKeymatchList(pageIndex: number, pageSize: number, sortBy: string, clientId: string, keymatchFilter: string){
    this.isLoading = true;
    this.hasError = false;
    this.clientService.getKeymatchList(pageIndex, pageSize, sortBy, clientId, keymatchFilter ).pipe(finalize(() => { 
      this.isLoading = false;
      this.keymatchList$.next();
     })).subscribe({
      next: (response) => {
        this.dataSourceKeyMatch.data = response.content;
        this.keymatchTotalItems = response.totalElements;
        // allinea lo stato locale con quanto ritorna il BE
        this.keymatchPageIndex = (response?.number ?? pageIndex) ?? 0;
        this.keymatchPageSize  = (response?.size ?? pageSize) ?? this.keymatchPageSize;
      },
      error: (err) => {
        console.log("errore nel recupero dei dati", err);
        this.dataSourceKeyMatch.data = [];
        this.keymatchTotalItems = 0;
        this.hasError = true;
      }
    })
  }

  loadExcludeUrl(pageIndex: number, pageSize: number, sortBy: string, clientId: string, urlClientExclusionFilter: string){
    this.isLoading = true;
    this.hasError = false;
    this.clientService.getExcludeUrlList(pageIndex, pageSize, sortBy, clientId, urlClientExclusionFilter ).pipe(finalize(() => { 
      this.isLoading = false;
      this.escludiUrlList$.next();
     })).subscribe({
      next: (response) => {
        this.dataSourceEscludiUrl.data = response.content;
        this.escludiUrlTotalItems = response.totalElements;
        // allinea lo stato locale con quanto ritorna il BE
        this.escludiUrlPageIndex = (response?.number ?? pageIndex) ?? 0;
        this.escludiUrlPageSize  = (response?.size ?? pageSize) ?? this.escludiUrlPageSize;
      },
      error: (err) => {
        console.log("errore nel recupero dei dati", err);
        this.dataSourceEscludiUrl.data = [];
        this.escludiUrlTotalItems = 0;
        this.hasError = true;
      }
    })
  }

  loadPolicyDiff(pageIndex: number, pageSize: number, sortBy: string, clientId: string, biasingFilter: string){
    this.isLoading = true;
    this.hasError = false;
    this.clientService.getPolicyDiffList(pageIndex, pageSize, sortBy, clientId, biasingFilter ).pipe(finalize(() => { 
      this.isLoading = false;
      this.policyDiffList$.next();
     })).subscribe({
      next: (response) => {
        this.dataSourcePolicyDiff.data = response.content;
        this.policyDiffTotalItems = response.totalElements;
        // allinea lo stato locale con quanto ritorna il BE
        this.policyDiffPageIndex = (response?.number ?? pageIndex) ?? 0;
        this.policyDiffPageSize  = (response?.size ?? pageSize) ?? this.policyDiffPageSize;
      },
      error: (err) => {
        console.log("errore nel recupero dei dati", err);
        this.dataSourcePolicyDiff.data = [];
        this.policyDiffTotalItems = 0;
        this.hasError = true;
      }
    })
  }

  onTabChanged(event: MatTabChangeEvent){
    switch(event.index){
      case 0: 
        this.activeTab = 'dynamicNav';
        break;
      case 1:
        this.activeTab = 'keymatch';
        break;
      case 2:
        this.activeTab = 'onebox';
        break;
      case 3:
        this.activeTab = 'queryCorrelate';
        break;
      case 4:
        this.activeTab = 'escludiUrl';
        break;
      case 5:
        this.activeTab = 'policyDiff';
        break;
      default:
        this.activeTab = '';
    }
  }

  importExportDocs(event: any){
    console.log('export or import', event);
    switch (event) {
      case 'import':
        this.csvInput.nativeElement.click();
        break;
      case 'export':
        console.log('export!!');
        this.isLoadingFullScreen = true;
        this.clientService.exportKeymatchCsv(this.id!).pipe(finalize(()=>{this.isLoadingFullScreen = false})).subscribe({
          next: (csv: string) => {
            this.downloadCsv(csv);
            this.notificationService.exportSuccess();
          },
          error: (err) => {
            this.notificationService.exportError();
            console.log("errore nella richiesta", err);
          }
        })
        break;

    }
  }

  downloadCsv(csv: string){
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const url = window.URL.createObjectURL(blob);
    const fileName = `keymatch_export_${this.id}.csv`;
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  onCsvSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if(!input.files?.length) {
      return;
    }
    this.isLoadingFullScreen = true;

    const file = input.files[0];
    console.log('file', file);

    const formData = new FormData();
    formData.append('file', file);

    console.log('formdata', formData);
    this.clientService.importKeymatchCsv(this.id!, formData).pipe(finalize(() => {this.isLoadingFullScreen = false})).subscribe({
      next: () => {
        this.loadKeymatchList(this.keymatchPageIndex, this.keymatchPageSize, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
        this.keymatchList$.pipe(take(1)).subscribe(() => {
                    this.notificationService.importSuccess();
                })
      },
      error: (err) => {
        this.notificationService.importError();
        console.log("errore nella richiesta", err);
      } 

    })

    input.value = '';
  }

  // Filtro: riparti sempre da pagina 0
  onFilterChanged(value: any){
    console.log('value filtro', value);

    if(this.activeTab === 'onebox'){
      this.oneboxSearchQuery = value.nome ?? '';
      this.loadOneBoxList(0, this.oneboxPageSize, this.oneboxSortBy, this.id!, this.oneboxSearchQuery);
    }
    if(this.activeTab === 'dynamicNav'){
      this.dynamicNavSearchQuery = value ?? {};
      this.loadDynamicNavigationList(0, this.dynamicNavPageSize, this.dynamicNavSortBy, this.id!, this.dynamicNavSearchQuery);
    }
    if(this.activeTab === 'queryCorrelate'){
      this.queryCorrelateSearchQuery = value.keyword ?? '';
      this.loadQueryRelatedList(0, this.queryCorrelatePageSize, this.queryCorrelateSortBy, this.id!, this.queryCorrelateSearchQuery);
    }
    if(this.activeTab === 'keymatch'){
      this.keymatchSearchQuery = value.title ?? '';
      this.loadKeymatchList(0, this.keymatchPageSize, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
    }
    if(this.activeTab === 'escludiUrl'){
      this.escludiUrlSearchQuery = value.urlPattern ?? '';
      this.loadExcludeUrl(0, this.escludiUrlPageSize, this.escludiUrlSortBy, this.id!, this.escludiUrlSearchQuery);
    }
    if(this.activeTab === 'policyDiff'){
      this.policyDiffSearchQuery = value.name ?? '';
      this.loadPolicyDiff(0, this.policyDiffPageSize, this.policyDiffSortBy, this.id!, this.policyDiffSearchQuery);
    }
    
  }

  onSortChanged(sort: Sort){
   
    console.log("ordinamento", sort);

    if(this.activeTab === 'onebox'){
      this.oneboxSortField = sort.active;
      this.oneboxSortDirection = sort.direction || 'asc';
      this.oneboxSortBy = `${this.oneboxSortField}:${this.oneboxSortDirection}`;
      this.loadOneBoxList(0, this.oneboxPageSize, this.oneboxSortBy, this.id!, this.oneboxSearchQuery);
    }
    if(this.activeTab === 'dynamicNav'){
      this.dynamicNavSortField = sort.active;
      this.dynamicNavSortDirection = sort.direction;

      if(this.dynamicNavSortDirection === ''){
        this.dynamicNavSortField = 'sorting';
        this.dynamicNavSortDirection = 'asc';
      }
      this.dynamicNavSortBy = `${this.dynamicNavSortField}:${this.dynamicNavSortDirection}`;
      this.loadDynamicNavigationList(0, this.dynamicNavPageSize, this.dynamicNavSortBy, this.id!, this.dynamicNavSearchQuery);
    }
    if(this.activeTab === 'queryCorrelate'){
      this.queryCorrelateSortField = sort.active;
      this.queryCorrelateSortDirection = sort.direction || 'asc';
      this.queryCorrelateSortBy = `${this.queryCorrelateSortField}:${this.queryCorrelateSortDirection}`;
      this.loadQueryRelatedList(0, this.queryCorrelatePageSize, this.queryCorrelateSortBy, this.id!, this.queryCorrelateSearchQuery);
    }
    if(this.activeTab === 'keymatch'){
      this.keymatchSortField = sort.active;
      this.keymatchSortDirection = sort.direction || 'asc';
      this.keymatchSortBy = `${this.keymatchSortField}:${this.keymatchSortDirection}`;
      this.loadKeymatchList(0, this.keymatchPageSize, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
    }
    if(this.activeTab === 'escludiUrl'){
      this.escludiUrlSortField = sort.active;
      this.escludiUrlSortDirection = sort.direction || 'asc';
      this.escludiUrlSortBy = `${this.escludiUrlSortField}:${this.escludiUrlSortDirection}`;
      this.loadExcludeUrl(0, this.escludiUrlPageSize, this.escludiUrlSortBy, this.id!, this.escludiUrlSearchQuery);
    }
    if(this.activeTab === 'policyDiff'){
      this.policyDiffSortField = sort.active;
      this.policyDiffSortDirection = sort.direction || 'asc';
      this.policyDiffSortBy = `${this.policyDiffSortField}:${this.policyDiffSortDirection}`;
      this.loadPolicyDiff(0, this.policyDiffPageSize, this.policyDiffSortBy, this.id!, this.policyDiffSearchQuery);
    }

  }

  canDoActions(role: string): boolean {
    return this.auth.hasRole(role);
  }

  onToggleChange(event: MatSlideToggleChange){
    const valueAutolearning = event.checked;
    const idClient = this.id!;
    this.isLoading = true;

    this.clientService.setAutolearning(idClient, valueAutolearning).pipe(finalize(() => this.isLoading = false)).subscribe({
      next: () => {
        this.isActive = valueAutolearning;
        this.notificationService.entitySuccess('update', 'Autolearning');
      },
      error: (err) => {
        this.isActive = !valueAutolearning;
        this.notificationService.entityError('update', 'Autolearning');
        console.log("errore nella richiesta", err);
      }
    })


  }

  // Cambio pagina / page size dal paginator (server-side)
  onPageChanged(ev: PageEvent) {

    if(this.activeTab === 'onebox'){
      this.oneboxPageIndex = ev.pageIndex;
      this.oneboxPageSize = ev.pageSize;
      this.loadOneBoxList(this.oneboxPageIndex, this.oneboxPageSize, this.oneboxSortBy, this.id!, this.oneboxSearchQuery);
    }
    if(this.activeTab === 'dynamicNav'){
      this.dynamicNavPageIndex = ev.pageIndex;
      this.dynamicNavPageSize = ev.pageSize;
      this.loadDynamicNavigationList(this.dynamicNavPageIndex, this.dynamicNavPageSize, this.dynamicNavSortBy, this.id!, this.dynamicNavSearchQuery);
    }
    if(this.activeTab === 'queryCorrelate'){
      this.queryCorrelatePageIndex = ev.pageIndex;
      this.queryCorrelatePageSize = ev.pageSize;
      this.loadQueryRelatedList(this.queryCorrelatePageIndex, this.queryCorrelatePageSize, this.queryCorrelateSortBy, this.id!, this.queryCorrelateSearchQuery);
    }
    if(this.activeTab === 'keymatch'){
      this.keymatchPageIndex = ev.pageIndex;
      this.keymatchPageSize = ev.pageSize;
      this.loadKeymatchList(this.keymatchPageIndex, this.keymatchPageSize, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
    }
    if(this.activeTab === 'escludiUrl'){
      this.escludiUrlPageIndex = ev.pageIndex;
      this.escludiUrlPageSize = ev.pageSize;
      this.loadExcludeUrl(this.escludiUrlPageIndex, this.escludiUrlPageSize, this.escludiUrlSortBy, this.id!, this.escludiUrlSearchQuery);
    }
    if(this.activeTab === 'policyDiff'){
      this.policyDiffPageIndex = ev.pageIndex;
      this.policyDiffPageSize = ev.pageSize;
      this.loadPolicyDiff(this.policyDiffPageIndex, this.policyDiffPageSize, this.policyDiffSortBy, this.id!, this.policyDiffSearchQuery);
    }
  }

  changeRowOrder(positions: any){
    console.log('evento', positions);
    const idClient = this.id!;
    const sortingPayload = {...positions, clientId: idClient};
    this.isLoadingFullScreen = true;
    this.clientService.changeDynamicNavRowOrder(sortingPayload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
      next: (response) => {
        console.log('response', response);
      },
      error: (err) => {
        console.log('errore', err);
      } 
    })
  }

  getSelectOptionsForModal(tab: string, modalIInstance?: any, action?: string){
    const config = this.tableConfigs[tab];
    if(tab === 'dynamicNav'){
      config.loadingSelect!['fieldId'] = true;
      config.errorSelect!['fieldId'] = false;

      this.clientService.getAllFields().subscribe({
        next: (response) => {
          //aggiorno le opzioni dinamiche del config 
          console.log('meta options', response);
          console.log('meta options è un array', Array.isArray(response));
          const metaOptions = response as Array<{value: string; label: string; system: boolean}>;
          config.selectOptions['fieldId'] = metaOptions.filter((x:any) => x.system === false).map((x:any) => ({
            value: x.id,
            label: x.name
          }))
          config.loadingSelect!['fieldId'] = false;
          
          if(modalIInstance?.formData){
            const isReadonlyInEdit = config.readonlyFields?.edit?.includes('fieldId') && action === 'edit';

            if(!isReadonlyInEdit){
              modalIInstance.formData.get('fieldId')?.enable();
            }
          }
        },
        error: () => {
          config.selectOptions!['fieldId'] = [];
          config.loadingSelect!['fieldId'] = false;
          config.errorSelect!['fieldId'] = true;
        } 
        
      });
    }
    if(tab === 'policyDiff'){
      config.loadingSelect!['selectPolicy'] = true;
      config.errorSelect!['selectPolicy'] = false;

      this.biasingService.getBiasingListAll().subscribe({
        next: (response) => {
          const policyOptions = response as Array<{value: string; label: string}>
          config.selectOptions['selectPolicy'] = policyOptions.map((x: any) => ({
            value: x.id,
            label: x.name
          }))
          config.loadingSelect!['selectPolicy'] = false;

          if(modalIInstance?.formData){
            const isReadonlyInEdit = config.readonlyFields?.edit?.includes('selectPolicy') && action === 'edit';

            if(!isReadonlyInEdit){
              modalIInstance.formData.get('selectPolicy')?.enable();
            }
          }
        },
        error: () => {
          config.selectOptions!['selectPolicy'] = [];
          config.loadingSelect!['selectPolicy'] = false;
          config.errorSelect!['selectPolicy'] = true;
        } 
        
      })
    }
    if(tab === 'onebox'){
      config.loadingSelect!['name'] = true;
      config.errorSelect!['name'] = false;

      this.clientService.getOneBoxListAll().subscribe({
        next: (response) => {
          const oneboxOptions = response as Array<{value: string; label: string}>
          config.selectOptions['name'] = oneboxOptions.map((x: any) => ({
            value: x.id,
            label: x.name
          }))
          config.loadingSelect!['name'] = false;

          if(modalIInstance?.formData){
            const isReadonlyInEdit = config.readonlyFields?.edit?.includes('name') && action === 'edit';

            if(!isReadonlyInEdit){
              modalIInstance.formData.get('name')?.enable();
            }
          }
        },
        error: () => {
          config.selectOptions!['name'] = [];
          config.loadingSelect!['name'] = false;
          config.errorSelect!['name'] = true;
        } 
        
      })
    }
  }

  openDialog(event : {data: any, type: 'add' | 'edit' | 'delete'}){
      
      const activatedTab = this.activeTab;

      if(event.type === 'add' && activatedTab === 'policyDiff' && this.dataSourcePolicyDiff.data.length >= 1){
        this.dialog.open(ConfirmModalComponent, {
          width: '400px',
          data: {
            message: 'Non è possibile aggiungere ulteriori associazioni a policy di differenziazione dei risultati.',
            title: 'Attenzione'
          }
        });
        return;
      }

      const config  = this.tableConfigs[activatedTab];
      

      const dialogRef = this.dialog.open(ModalComponent, {
        width: '400px',
        data: {
          action: event.type,
          payload: event.data,
          visibleFields: config.visibleFields,
          nonRequiredFields: config.nonRequiredFields, //campi facoltativi
          hiddenFields: config.hiddenFields, //campi che voglio nel form anche se nascosti
          hiddenFieldsValues: config.hiddenFieldsValues, //campi nascosti che valorizzo 
          labels: config.labels,
          fieldTypes: config.fieldTypes, // tipologia dei campi contenuti in modale
          selectOptions: config.selectOptions, // se presente un campo di tipo select, le opzioni della select
          loadingSelect: config.loadingSelect,
          errorSelect: config.errorSelect
        } 
      });

      this.getSelectOptionsForModal(activatedTab, dialogRef.componentInstance, event.type);
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('result', result);
        if(result){

          this.isLoadingFullScreen = true;

          //caso dynamicNav 
          if(activatedTab === 'dynamicNav'){
            if(event.type === 'add') {
              const payload = {...result, clientId: this.id};
              
              this.clientService.addNewDynamicNavigation(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                this.loadDynamicNavigationList(this.dynamicNavPageIndex, this.dynamicNavPageSize, this.dynamicNavSortBy, this.id!, this.dynamicNavSearchQuery);
                this.dynamicNavList$.pipe(take(1)).subscribe(() => {
                    this.notificationService.entitySuccess('add', 'Dynamic Navigation');
                })
              },
              error: (err) => {
                this.notificationService.entityError('add', 'Dynamic Navigation');
                console.log("errore nella richiesta", err);
              }
            });
            
          } else if (event.type === 'edit') {
            const index = this.dataSourceDynamicNav.data.findIndex( (el: any) => el.id === result.id);
            const payload = {...result, clientId: this.id};
            
            if (index !== -1){
              this.clientService.editDynamicNavigation(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
                next: () => {
                  this.loadDynamicNavigationList(this.dynamicNavPageIndex, this.dynamicNavPageSize, this.dynamicNavSortBy, this.id!, this.dynamicNavSearchQuery);
                  this.dynamicNavList$.pipe(take(1)).subscribe(() => {
                      this.notificationService.entitySuccess('update', 'Dynamic Navigation');
                  })
                },
                error: (err) => {
                  this.notificationService.entityError('update', 'Dynamic Navigation');
                  console.log("errore nella richiesta", err);
                }
              });
              
            } 
          } else if (event.type === 'delete'){
            
            this.clientService.deleteDynamicNavigation(result.id).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                this.loadDynamicNavigationList(this.dynamicNavPageIndex, this.dynamicNavPageSize, this.dynamicNavSortBy, this.id!, this.dynamicNavSearchQuery);
                this.dynamicNavList$.pipe(take(1)).subscribe(() => {
                    this.notificationService.entitySuccess('delete', 'Dynamic Navigation');
                })
              },
              error: (err) => {
                 this.notificationService.entityError('delete', 'Dynamic Navigation');
                console.log("errore nella richiesta", err);
              }
            });
          } 
        }
        //caso KEYMATCH
        if(activatedTab === 'keymatch'){
          if(event.type === 'add') {
              const payload = {...result, idClient: this.id};
              
              this.clientService.addKeymatch(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                this.loadKeymatchList(this.keymatchPageIndex, this.keymatchPageSize, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
                this.keymatchList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('add', 'Keymatch');
                })
              },
              error: (err) => {
                 this.notificationService.entityError('add', 'Keymatch');
                console.log("errore nella richiesta", err);
              } 
            });
            
          } else if (event.type === 'edit') {
            
            const index = this.dataSourceKeyMatch.data.findIndex( (el: any) => el.id === result.id);
            const payload = {...result, idClient: this.id};
            
            if (index !== -1){
              this.clientService.editKeymatch(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
                next: () => {
                  
                  this.loadKeymatchList(this.keymatchPageIndex, this.keymatchPageSize, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
                  this.keymatchList$.pipe(take(1)).subscribe(() => {
                    this.notificationService.entitySuccess('update', 'Keymatch');
                  })
                },
                error: (err) => {
                   this.notificationService.entityError('update', 'Keymatch');
                  console.log("errore nella richiesta", err);
                }
              });
              
            }
          } else if (event.type === 'delete'){
            
            this.clientService.deleteKeymatch(result.id).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadKeymatchList(this.keymatchPageIndex, this.keymatchPageSize, this.keymatchSortBy, this.id!, this.keymatchSearchQuery);
                this.keymatchList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('delete', 'Keymatch');
                })
              },
              error: (err) => {
                 this.notificationService.entityError('delete', 'Keymatch');
                console.log("errore nella richiesta", err);
              }
            });
          } 
        }
        //caso ONEBOX
        if(activatedTab === 'onebox'){
          if(event.type === 'add') {
              const clientId = this.id;
              const oneboxId = result.name;
              
              this.clientService.associateOnebox(clientId, oneboxId).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadOneBoxList(this.oneboxPageIndex, this.oneboxPageSize, this.oneboxSortBy, this.id!, this.oneboxSearchQuery);
                this.oneboxList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('add', 'Onebox');
                })
              },
              error: (err) => {
                 this.notificationService.entityError('add', 'Onebox');
                console.log("errore nella richiesta", err);
              } 
            });
            
          } else if (event.type === 'delete'){
            const clientId = this.id;
            const oneboxId = result.id;
            
            this.clientService.removeOneboxFromClient(clientId, oneboxId).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadOneBoxList(this.oneboxPageIndex, this.oneboxPageSize, this.oneboxSortBy, this.id!, this.oneboxSearchQuery);
                this.oneboxList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('delete', 'Onebox');
                })
              },
              error: (err) => {
                 this.notificationService.entityError('delete', 'Onebox');
                console.log("errore nella richiesta", err);
              }
            });
          } 
        }
        //caso Related Query
        if(activatedTab === 'queryCorrelate'){
          if(event.type === 'add') {
              const payload = {...result, clientId: this.id};
              
              this.clientService.addRelatedQuery(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadQueryRelatedList(this.queryCorrelatePageIndex, this.queryCorrelatePageSize, this.queryCorrelateSortBy, this.id!, this.queryCorrelateSearchQuery);
                this.queryCorrelateList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('add', 'Query');
                })
              },
              error: (err) => {
                this.notificationService.entityError('add', 'Query');
                console.log("errore nella richiesta", err);
              } 
            });
            
          } else if (event.type === 'edit') {
            const index = this.dataSourceQueryCorrelate.data.findIndex( (el: any) => el.id === result.id);
            const payload = {...result, clientId: this.id};
            
            if (index !== -1){
              this.clientService.editRelatedQuery(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
                next: () => {
                  
                  this.loadQueryRelatedList(this.queryCorrelatePageIndex, this.queryCorrelatePageSize, this.queryCorrelateSortBy, this.id!, this.queryCorrelateSearchQuery);
                  this.queryCorrelateList$.pipe(take(1)).subscribe(() => {
                    this.notificationService.entitySuccess('update', 'Query');
                  })
                },
                error: (err) => {
                  this.notificationService.entityError('update', 'Query');
                  console.log("errore nella richiesta", err);
                }
              });
              
            }
          } else if (event.type === 'delete'){
            this.clientService.deleteRelatedQuery(result.id).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadQueryRelatedList(this.queryCorrelatePageIndex, this.queryCorrelatePageSize, this.queryCorrelateSortBy, this.id!, this.queryCorrelateSearchQuery);
                this.queryCorrelateList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('delete', 'Query');
                })
              },
              error: (err) => {
                this.notificationService.entityError('delete', 'Query');
                console.log("errore nella richiesta", err);
              }
            });
          } 
        }
        //caso escludiUrl
        if(activatedTab === 'escludiUrl'){
          if(event.type === 'add') {
              const payload = {...result, clientId: this.id};
              
              this.clientService.addExcludeUrl(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadExcludeUrl(this.escludiUrlPageIndex, this.escludiUrlPageSize, this.escludiUrlSortBy, this.id!, this.escludiUrlSearchQuery);
                this.escludiUrlList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('add', 'Url');
                })
              },
              error: (err) => {
                this.notificationService.entityError('add', 'Url');
                console.log("errore nella richiesta", err);
              } 
            });
            
          } else if (event.type === 'edit') {
            const index = this.dataSourceEscludiUrl.data.findIndex( (el: any) => el.id === result.id);
            const payload = {...result, clientId: this.id};
            
            if (index !== -1){
              this.clientService.editExcludeUrl(payload).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
                next: () => {
                  
                  this.loadExcludeUrl(this.escludiUrlPageIndex, this.escludiUrlPageSize, this.escludiUrlSortBy, this.id!, this.escludiUrlSearchQuery);
                  this.escludiUrlList$.pipe(take(1)).subscribe(() => {
                    this.notificationService.entitySuccess('update', 'Url');
                  })
                },
                error: (err) => {
                  this.notificationService.entityError('update', 'Url');
                  console.log("errore nella richiesta", err);
                }
              });
              
            }
          } else if (event.type === 'delete'){
            this.clientService.deleteExcludeUrl(result.id).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadExcludeUrl(this.escludiUrlPageIndex, this.escludiUrlPageSize, this.escludiUrlSortBy, this.id!, this.escludiUrlSearchQuery);
                this.escludiUrlList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('delete', 'Url');
                })
              },
              error: (err) => {
                this.notificationService.entityError('delete', 'Url');
                console.log("errore nella richiesta", err);
              }
            });
          } 
        }
        //caso PolicyDiff
        if(activatedTab === 'policyDiff'){
          if(event.type === 'add') {
              const clientId = this.id;
              const biasingId = result.selectPolicy;
              this.clientService.associateBiasingPolicy(clientId, biasingId).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadPolicyDiff(this.policyDiffPageIndex, this.policyDiffPageSize, this.policyDiffSortBy, this.id!, this.policyDiffSearchQuery);
                this.policyDiffList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('add', 'Biasing Policy');
                })
              },
              error: (err) => {
                this.notificationService.entityError('add', 'Biasing Policy');
                console.log("errore nella richiesta", err);
              } 
            });
            
          } else if (event.type === 'delete'){
            const clientId = this.id;
            const biasingId = result.id;
            this.clientService.removeBiasingPolicyFromClient(clientId, biasingId).pipe(finalize(() => { this.isLoadingFullScreen = false; })).subscribe({
              next: () => {
                
                this.loadPolicyDiff(this.policyDiffPageIndex, this.policyDiffPageSize, this.policyDiffSortBy, this.id!, this.policyDiffSearchQuery);
                this.policyDiffList$.pipe(take(1)).subscribe(() => {
                  this.notificationService.entitySuccess('delete', 'Biasing Policy');
                })
              },
              error: (err) => {
                this.notificationService.entityError('delete', 'Biasing Policy');
                console.log("errore nella richiesta", err);
              }
            });
          } 
        }

        } 
          
       });
  }

  ngOnDestroy(): void {
    this.dynamicNavList$.complete();
    this.keymatchList$.complete();
    this.oneboxList$.complete();
    this.queryCorrelateList$.complete();
    this.escludiUrlList$.complete();
    this.policyDiffList$.complete();
    this.clientById$.complete();
  }

 }

